export const VARIANTS = {
  SEPARATE: 'separate',
};
